import { render, staticRenderFns } from "./ProductControl.vue?vue&type=template&id=32aa5a7f&scoped=true"
import script from "./ProductControl.vue?vue&type=script&lang=js"
export * from "./ProductControl.vue?vue&type=script&lang=js"
import style0 from "./ProductControl.vue?vue&type=style&index=0&id=32aa5a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aa5a7f",
  null
  
)

export default component.exports